/**
 * Get mood color based on score (-100 to 100 scale)
 * Negative scores are more red, positive scores are more green
 */
export function getMoodColor(score: number): string {
  if (score === null || score === undefined) {
    return 'rgb(200, 200, 200)';
  }

  // Normalize score to -100 to 100 range
  const normalizedScore = Math.max(-100, Math.min(100, score));

  let red: number;
  let green: number;
  const blue = 170;

  if (normalizedScore < 0) {
    // Negative scores: more red
    red = 255;
    green = 255 - 102 * (Math.abs(normalizedScore) / 100);
  } else {
    // Positive scores: more green
    red = 255 - 102 * (normalizedScore / 100);
    green = 255;
  }

  return `rgb(${Math.round(red)}, ${Math.round(green)}, ${blue})`;
}

/**
 * Convert RGB color to RGBA with alpha
 */
export function toRGBA(rgb: string, alpha: number): string {
  return rgb.replace('rgb', 'rgba').replace(')', `, ${alpha})`);
}

/**
 * Get weekday labels starting from Monday
 */
export function getWeekdayLabels(locale: string = 'en'): string[] {
  const formatter = new Intl.DateTimeFormat(locale, { weekday: 'short' });
  // Create a date for each day of the week starting from Monday (Jan 1, 2024 was a Monday)
  const days = [];
  for (let i = 1; i <= 7; i++) {
    const date = new Date(2024, 0, i); // Jan 1-7, 2024 (Mon-Sun)
    days.push(formatter.format(date));
  }
  return days;
}

/**
 * Weekday indices for Monday-Sunday order
 */
export const WEEKDAY_ORDER = [1, 2, 3, 4, 5, 6, 0]; // Monday=1 to Sunday=0
